import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://nrscjwoqheybgvqrjwac.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5yc2Nqd29xaGV5Ymd2cXJqd2FjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE1MzY4MzQsImV4cCI6MjA2NzExMjgzNH0.9mVC-DWedbtB_VG7Q8orseGQWmJ5B6MDOyo_k650zo4'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})